var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v(" Hmm... Seems you are looking for something that doesn't exist or has moved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }